const t = {
  name: "Luxembourg",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 5.82929C14.1652 5.41746 15 4.30622 15 3C15 1.34315 13.6569 0 12 0C10.3431 0 9 1.34315 9 3C9 4.30622 9.83481 5.41746 11 5.82929V7H10.095L9.09502 17H7V22H4V24H20V22H17V17H14.905L13.905 7H13V5.82929ZM12 2C12.5523 2 13 2.44772 13 3C13 3.55228 12.5523 4 12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2ZM12.095 9L12.895 17H11.105L11.905 9H12.095ZM9 19H15V22H9V19Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Luxembourg
};
